import {
    animate,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';

export const NgIfAnimation = trigger('conditionalTrigger', [
    state('shown', style({})),

    transition('void => shown', [
        style({
            opacity: 0,
        }),
        animate(1000, style({ opacity: 1 })),
    ]),

    transition('shown => void', [animate(1000, style({ opacity: 0 }))]),
]);